(function() {
	'use strict';
	angular.module('app.setup')
		.controller('manageCurrencyConversion', manageCurrencyConversion);

	manageCurrencyConversion.$inject = ['$rootScope', '$scope', '$timeout', '$compile', '$uibModal', 'factorySettingService', 'storeService'];
	
	function manageCurrencyConversion($rootScope, $scope, $timeout, $compile, $uibModal, factorySettingService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.currencies = $scope.currencies;
		vm.factoryCurrency = $scope.factoryCurrency;
		vm.customerCurrency = $scope.customerCurrency;
		vm.manageCurrencyConversions = [];

		// view model functions
		vm.showEdit = showEdit;
		vm.cancelEdit = cancelEdit;
		vm.saveEdit = saveEdit;
		vm.close = close;
		vm.updateField = updateField;
		vm.addCurrencyConversion = addCurrencyConversion;
		vm.deleteFieldValue = deleteFieldValue;
		getFactoryCurrencyConversions();
	
		function getFactoryCurrencyConversions() {
			factorySettingService.getFactoryCurrencyConversions(adminConfig.factory.id).then(function(response) {
				var manageCurrencyConversions = response;
				if (manageCurrencyConversions && manageCurrencyConversions.length) {
					vm.manageCurrencyConversions = manageCurrencyConversions;
				} else {
					vm.manageCurrencyConversions = [];
				}
			});
		}

		function updateField() {
			if (vm.field.fieldType === 'DROPDOWN') {
				vm.isDropDownField = true;
			} else {
				vm.isDropDownField = false;
			}
			vm.field.manageCurrencyConversion = [];
		}
		
		function close() {
			$scope.result('', false);
		}
		
		function isValueAreadyExists() {
			return _.some(vm.manageCurrencyConversions, function (manageCurrencyConversion) {
				return manageCurrencyConversion.sourceCurrency === vm.sourceCurrency &&
					manageCurrencyConversion.targetCurrency === vm.targetCurrency && manageCurrencyConversion.conversionFactor === vm.conversionFactor;
			});
		}
		
		function addCurrencyConversion() {
			if (vm.sourceCurrency && vm.targetCurrency && !isValueAreadyExists()) {
				var saveObj = {};
				saveObj['sourceCurrency'] = vm.sourceCurrency;
				saveObj['targetCurrency'] = vm.targetCurrency;
				saveObj['conversionFactor'] = vm.conversionFactor;
				factorySettingService.addCurrencyConversion(saveObj, adminConfig.factory.id)
				.then(function(response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {'message': 'Currency mapping was saved successfully', 'success': true});
						getFactoryCurrencyConversions();
					} else {
						$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
					}
				});
			}
		}
		
		function deleteFieldValue(index) {
			var confirmScope = $scope.$new();
			confirmScope.valueNdx = vm.manageCurrencyConversions[index].ndx;
			confirmScope.additionalText = 'delete this value';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var valueNdx = confirmScope.valueNdx;
				instance.close();
				confirmScope.$destroy();
				factorySettingService.deleteCurrencyConversionMapping(valueNdx, adminConfig.factory.id).then(function(message) {
					var isSuccessful = (message == 'Mapping deleted successfully');
					$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
					if (isSuccessful) {
						getFactoryCurrencyConversions();
					}
				});
			};
		}
		
		function getTemplate(position, rowIndex) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			position.left = 20;
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var header = 'Edit Value';
			var scopeModal = 'manageCurrencyConversionCtrl.editFieldValue';
			var editTemplate = '<div class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">' + header + '</div>' +
				'<div id="errorMsg" style="color:red;" class="hide"></div>' +
				'<span id="errorMsg" style="color:red;" class="hide"></span>' +
				'<input class="inlineEditInput" type="number" min="1" ng-min="1" ng-model="' + scopeModal + '" />' +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="manageCurrencyConversionCtrl.cancelEdit()">Cancel</a>' +
				'<a class="button flat colored" ng-click="manageCurrencyConversionCtrl.saveEdit(' + rowIndex + ')">Save</a></div></div>';
			return editTemplate;
		}
		
		function showEdit(index) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#fieldValue' + index);
			var pos = cell.offset();

			var content = parseInt(cell.text());
			var editTemplate = getTemplate(pos, index);
			var compiledDiv = $compile(editTemplate)($scope);
			vm.editFieldValue = content;
			
			jQuery('#manageCurrencyConversionForm').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					vm.saveEdit(index, type);
				} else if (code == 27) {
					vm.cancelEdit();
				}
			});
			
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		};

		
		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		};

		function saveEdit(index) {
			var content = strip(vm.editFieldValue);	
			var saveObj = {};
			saveObj.ndx = vm.manageCurrencyConversions[index].ndx;
			var tempField = vm.manageCurrencyConversions[index].conversionFactor;
			
			if (tempField != content) {
				if (isNaN(content)) {
					jQuery('.inlineEditDiv.textEdit').height(115);
					jQuery('#errorMsg').text('Only numeric value is allowed').removeClass('hide');
					return false;
				}
				saveObj['conversionFactor'] = content;
				factorySettingService.updateCurrencyConversionFactor(saveObj.ndx, saveObj, adminConfig.factory.id)
					.then(function(response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {'message': 'Currency Conversion Factor Value was saved successfully', 'success': true});
							getFactoryCurrencyConversions();
						} else {
							$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
						}
					});
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
			vm.cancelEdit();
		}
	}
})();
